import { START_LOCATION, type RouteLocationNormalized } from 'vue-router';

export const isQueryOnlyNavigation = (to: RouteLocationNormalized, from: RouteLocationNormalized) =>
  from !== START_LOCATION && to.path === from.path && to.fullPath !== from.fullPath;
